module.exports = __webpack_public_path__ + "static/biocheckfull-3f493b576f676baf4182eb2c5b16277e.jpg";